module.exports = __webpack_public_path__ + "img/HeresSomeErgoSetUpGuidelines.23fbf7d0.png";